import { DataSourceOverlay } from '../../DataSourceOverlay/DataSourceOverlay'
import { Label } from '../../Label/Label'

export const BadgeContent = ({
  name,
  children,
  showLabel,
  diameter,
  shouldAddDataSourceOverlay,
}: {
  name: string
  children: React.ReactNode
  showLabel: boolean
  diameter: number
  shouldAddDataSourceOverlay?: boolean
}) => (
  <>
    {showLabel && <Label bottom={diameter - 3}>{name}</Label>}
    <div
      css={{
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: 40,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {shouldAddDataSourceOverlay && (
        <DataSourceOverlay
          overlayCSS={{
            height: '100%',
            width: '100%',
            left: 0,
          }}
        />
      )}
      <div css={{ width: '100%' }}>{children}</div>
    </div>
  </>
)
